import api from './request'

const createSowingCell = (sowingCell, row, column, deviceId, warehouseId) => {
    return api.getPromise('sowing/createSowingCell', {
        sowingCell, row, column, deviceId, warehouseId
    })
}

const findAllSowingCells = (onlyParent, warehouseId) => {
    return api.getPromise('sowing/findAllSowingCells', {
        onlyParent, warehouseId
    })
}

const removeSowingCell = (sowingCellId) => {
    return api.getPromise('sowing/removeSowingCell', {sowingCellId})
}

const printCellLabel = (id, deviceId) => {
    return api.getPromise('sowing/printCellLabel', {
        id, deviceId
    })
}

const findSowingCellByQrCode = (qrCode) => {
    return api.getPromise('sowing/findSowingCellByQrCode', {qrCode})
    // return new Promise(resolve => {
    //     resolve({
    //         qrCode: '1#cs',
    //         id: 3
    //     })
    // })
}

const findSowingCellByParentAndStatus = (sowingCellId, status, showOccupied) => {
    return api.getPromise('warehouse/findSowingCellByParentAndStatus', {sowingCellId, status, showOccupied})
}

const releaseSowingCell = (sowingCellId) => {
    return api.getPromise('sowing/releaseSowingCell', {sowingCellId})
}

export default {
    createSowingCell,
    findAllSowingCells,
    removeSowingCell,
    printCellLabel,
    findSowingCellByQrCode,
    findSowingCellByParentAndStatus,
    releaseSowingCell
}



// WEBPACK FOOTER //
// ./src/request/sowingApi.js